const reducer = (state = 'All', action) =>{
    switch(action.type){
        case "setWorkflowStatus": 
            return action.payload;
        default: 
            return state;
    }
}

export default reducer;  